import { render, staticRenderFns } from "./violationRuleForm.vue?vue&type=template&id=503cedc2&scoped=true"
import script from "./violationRuleForm.vue?vue&type=script&lang=js"
export * from "./violationRuleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503cedc2",
  null
  
)

export default component.exports